import { Action } from '@ngrx/store';

export const CLOSE_POPIN = '[POPIN] closes the popin';
export const OPEN_POPIN = '[POPIN] opens the popin';

export class ClosePopin implements Action {
  readonly type = CLOSE_POPIN;
  constructor(public payload: { name: string }) {}
}

export class OpenPopin implements Action {
  readonly type = OPEN_POPIN;
  constructor(public payload: { name: string }) {}
}

export type PopinActions = ClosePopin | OpenPopin;
